<template>
  <div class="container">
    <div class="box">
      <div class="card-header has-background-light is-block">
        <h1 class="title is-4 is-block py-3 has-text-centered is-uppercase">
          {{ slidesContent.popupTitle }}
        </h1>
      </div>
      <div class="card-content py-16 px-10">
        <ul class="link-list px-1 py-2">
          <li
            v-for="(item, idx) in slidesContent.links"
            :key="'link_' + idx"
            class="link-item"
          >
            <a class="is-block is-hoverable" :href="item.url" target="_blank">
              <span class="is-block title is-4"
                ><b-icon icon="link" class="mr-3" size="is-small"></b-icon>
                {{ item.title }}</span
              >
              <span class="is-block subtitle is-5 has-text-link">{{
                item.subtitle
              }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["popup", "popupContent", "content"]),
    activeSlide() {
      return 1;
    },
    slidesContent() {
      if (this.popupContent < 0) return null;
      return this.content[this.popupContent];
    },
  },
};
</script>
<style scoped>
.link-item {
  border-bottom: 1px solid #ccc;
  padding: 20px 0;
}

.link-item a .title {
  color: #0c5eff;
}
.link-item a .subtitle {
  color: #aaa;
}
.link-item a:hover .title {
  color: #002f8b;
}
.link-item a:hover .subtitle {
  color: #666;
}
.box {
  max-height: 90vh;
}
.link-list {
  max-height: 65vh;
  overflow: auto;
}
</style>
